export const INFRA_PROVIDER =
  process.env.REACT_APP_INFRA_PROVIDER || "firebase";

export const isSelfHosted = INFRA_PROVIDER === "selfhosted";

export const AUTH_TOKEN_KEY = "platformAuthToken";
export const AUTH_USER_KEY = "platformAuthUser";

export interface StoredPlatformUser {
  uid: string;
  email?: string | null;
  displayName?: string | null;
  claims: Record<string, unknown>;
}

export const AUTH_SESSION_EVENT = "mayorx-platform-auth-changed";
